<template>
  <div class="main-template">
    <!-- {{ model }} -->
    <v-tabs class="ml-n2" ref="tabs" v-model="tabs">
      <v-tabs-slider color="yellow"></v-tabs-slider>

      <v-tab style="text-align: left" v-for="tab in item_tabs" :key="tab.name">
        <div>
          {{ tab.title }}
        </div>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <v-card class="ma-2 pa-2">
          <v-text-field
            label="Table Name"
            v-model="model.tbl_name"
          ></v-text-field>
          <v-text-field
            label="Mongo Name"
            v-model="model.mongo_table"
          ></v-text-field>
          <v-text-field label="Qry" v-model="model.qry"></v-text-field>
          <v-combobox
            label="Connection"
            v-model="model.conn"
            :items="connections"
          ></v-combobox>

          <v-card-actions>
            <v-btn
              @click="importTable()"
              color="primary"
              :loading="loading"
              type="submit"
              >Import Table</v-btn
            >
            <!-- <v-btn
              @click="getKeys()"
              color="primary"
              :loading="loading"
              type="submit"
              >Get Keys</v-btn
            > -->
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card class="ma-2 pa-2">
          <v-text-field
            label="Parent Table"
            v-model="merge.parent_table"
          ></v-text-field>
          <v-text-field
            label="Child Table"
            v-model="merge.child_table"
          ></v-text-field>
          <v-text-field
            label="Merge Field"
            v-model="merge.merge_field"
          ></v-text-field>
          <!-- <v-text-field label="New Table" v-model="merge.name"></v-text-field> -->
          <v-text-field label="Qry" v-model="merge.qry"></v-text-field>
          <v-text-field label="DB" v-model="merge.db"></v-text-field>
          <v-card-actions>
            <v-btn
              @click="mergeTables()"
              color="primary"
              :loading="loading"
              type="submit"
              >Merge Tables</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card class="ma-2 pa-2">
          <v-text-field
            v-model="selected_portal_id"
            @keyup.enter="getPortalData"
            label="Select PortalID"
            append-icon="mdi-magnify"
            @click:append="getPortalData"
          />

          <div v-if="portalSelected">
            <v-combobox
              label="Connection"
              v-model="model.conn"
              :items="connections"
            ></v-combobox>
            <v-text-field
              label="PortalID"
              v-model="model.portal_id"
              type="number"
            ></v-text-field>
            <v-text-field
              label="CompanyID"
              v-model="model.company_id"
            ></v-text-field>
            <v-text-field label="Admin" v-model="model.admin"></v-text-field>
            <v-text-field
              label="Admin Password"
              v-model="model.admin_password"
            ></v-text-field>
            <!-- {{ model }} -->
            <v-date-time
              label="From Date"
              :model="model.from_date"
              v-model="model.from_date"
              :noTime="true"
              :vModel="model.from_date"
            ></v-date-time>
            <v-text-field
              label="Number of Records"
              v-model="model.num_rec"
            ></v-text-field>
            <v-switch
              label="Include All Companies"
              v-model="model.include_all_companies"
            ></v-switch>
            <v-switch
              label="Create Defaults"
              v-model="model.create_defaults"
            ></v-switch>
            <v-switch label="Commercial" v-model="model.commercial"></v-switch>
            <v-text-field
              label="JSON File"
              v-model="model.json_file_name"
            ></v-text-field>

            <v-row dense v-for="t in importTables" :key="t.mongo_table">
              <v-col>
                <v-switch v-model="t.include"></v-switch>
              </v-col>
              <v-col>
                {{ t.tbl_name }}
              </v-col>
              <v-col>
                {{ t.mongo_table }}
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                @click="saveImport()"
                color="primary"
                :loading="loading"
                type="submit"
                >Import DB</v-btn
              >
              <div v-if="loading" class="ma-2">
                Process Running {{ timeElapsed }} sec
              </div>
              <v-btn
                @click="importUsers()"
                color="primary"
                v-if="!loading"
                type="submit"
                >Import Users</v-btn
              >
              <v-btn
                @click="stopImport()"
                color="error"
                v-if="loading"
                type="submit"
              >
                Abort
              </v-btn>
            </v-card-actions>
          </div>
          {{ serverMessage }}
          <!-- Time Elapsed:{{ timeElapsed }} -->
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <!-- <a :href="'#login/' + model.portal_id">Login To Portal</a> -->
    <v-alert
      class="ma-4"
      dismissible
      v-if="successMessage != ''"
      type="success"
    >
      {{ successMessage }}
    </v-alert>
    <v-alert
      class="ma-4"
      dismissible
      v-if="errorMessage != '' && errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>
  </div>
</template>
<script>
// import Vue from "vue";
// import VueAxios from "vue-axios";
import axios from "axios";
// Vue.use(VueAxios, axios);
import io from "socket.io-client";
import * as fun from "../plugins/common";
export default {
  name: "ImportTable",
  components: {
    VDateField: () => import("../components/DateField.vue"),
    VDateTime: () => import("../components/DateTime.vue"),
    // VUnitChargeTest: () => import("../components/UnitChargeTest.vue"),
    // VTreeInput: () => import("../components/TreeInput.vue"),
  },

  data() {
    return {
      progressMessage: "",
      start: null,
      selected_portal_id: null,
      socket: null,
      portalSelected: false,
      timeElapsed: 0,
      serverMessage: "",
      import: null,
      tabs: 2,
      importTables: [],
      item_tabs: [
        {
          title: "Import Tables",
          name: "import",
        },
        {
          title: "Merge Tables",
          name: "merge",
        },
        {
          title: "Import DB",
          name: "import_db",
        },
      ],
      model: {
        json_file_name: "import_emover_leads",
        // conn: "production",
        // company_id: "76",
        // portal_id: "71",
        //        admin: "gfuchs@ozmoving.com",
        // conn: "brs",
        // company_id: "52",
        // portal_id: "58",
        // admin: "jlinares@brsmove.com",
        // admin_password: "brs_2024",
        // from_date: "01/01/2025",
        num_rec: 10000,
      },
      merge: {
        parent_table: "emover_invoice",
        child_table: "emover_payment",
        name: "emover_invoices",
        merge_field: "InvoiceID",
      },
      successMessage: "",
      errorMessage: "",
      loading: false,
      connections: [
        "production",
        "moverai",
        "moverai_lead_manager",
        "eMoverNuke",
        "freed",
        "brs",
      ],
    };
  },
  methods: {
    deleteEmptyCustomers() {
      //       db.customer.deleteMany({
      //   _id: { $nin: db.shipment.distinct("customer") }
      // });
      // db.customer.updateMany(
      //   {},
      //   { $set: { type_of_customer: "commercial" } }
      // );
    },
    stopImport() {
      this.loading = false;
      axios.post(this.serverURL + "/stop_import").then((response) => {
        this.successMessage = response.data.message;
      });
    },
    getPortalData() {
      var data = {
        object_name: "import_db",
        qry: {
          portal_id: this.selected_portal_id,
        },
      };
      this.loading = true;
      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          this.loading = false;
          this.portalSelected = true;
          if (response.data.model) {
            this.model = response.data.model[0] || {};
            this.model.portal_id = this.selected_portal_id;
            this.model.json_file_name = "import_emover_leads";
          }
        });
    },
    saveImport() {
      var file_name = "import/" + this.model.json_file_name + ".json";
      this.timeElapsed = 0;
      var data = {
        metadata: {
          object_name: "import_db",
        },
        model: this.model,
      };
      this.axios.post(this.serverURL + "/add_data", data, {
        withCredentials: true,
      });

      axios
        .post(this.serverURL + "/add_file", {
          file_name: file_name,
          json: this.import,
        })
        .then((response) => {
          this.importDb();
        });
    },
    timer() {
      var that = this;
      if (!that.loading) {
        return;
      }
      that.timeElapsed = 0;
      setInterval(function() {
        if (!that.loading) {
          return;
        }
        var delta = Date.now() - that.start; // milliseconds elapsed since start

        that.timeElapsed = Math.floor(delta / 1000); // in seconds
        // alternatively just show wall clock time:
        // output(new Date().toUTCString());
      }, 1000);
    },
    importTable() {
      this.successMessage = "";
      var that = this;
      that.timeElapsed = 0;
      this.loading = true;

      this.axios
        .post(this.serverURL + "/import_table", that.model)
        .then(function(response) {
          that.loading = false;
          // console.log(response);
          if (response.message == "error") {
            that.errorMessage = "Error";
          } else {
            if (response.data == "error") {
              that.errorMessage = "Error";
            } else {
              that.successMessage = response.data;
            }
          }
        })
        .catch(function(error) {
          that.loading = false;
          that.errorMessage = error.data;
        });
    },
    importDb() {
      // this.saveImport();
      // return;
      this.successMessage = "";
      this.start = Date.now();
      var that = this;
      this.loading = true;
      this.timeElapsed = 0;
      this.timer();
      this.axios
        .post(this.serverURL + "/import_db", that.model)
        .then(function(response) {
          // that.loading = false;
          console.log(response);
          that.successMessage = response.data.message;
        })
        .catch(function(error) {
          that.loading = false;
          that.errorMessage = error.data;
        });
    },
    importUsers() {
      this.successMessage = "";
      var that = this;
      this.loading = true;
      this.axios
        .post(this.serverURL + "/import_users", that.model)
        .then(function(response) {
          that.loading = false;
          console.log(response);
          that.successMessage = response.data;
        })
        .catch(function(error) {
          that.loading = false;
          that.errorMessage = error.data;
        });
    },
    getKeys() {
      var that = this;
      this.loading = true;
      this.axios
        .post(this.serverURL + "/get_keys", that.model)
        .then(function(response) {
          that.loading = false;
          console.log(response);
          that.successMessage = response.data;
        })
        .catch(function(error) {
          that.loading = false;
          that.errorMessage = error.data;
        });
    },
    initSocket() {
      var socketUrl = fun.getSocketURL();
      socketUrl = "https://server.moverai.com:5000";

      this.socket = io(socketUrl);
    },
    mergeTables() {
      this.successMessage = "";
      var that = this;
      this.loading = true;

      var data = {
        local_collection: that.merge.parent_table,
        foreign_collection: that.merge.child_table,
        local_field: that.merge.merge_field,
        foreign_field: that.merge.merge_field,
        qry: that.merge.qry,
        // name: that.merge.name,
        // merge: { into: that.merge.new_collection },
        // select_fields: {
        //   shipment_id: "$shipment_id",
        //   first_name: "$customer.first_name",
        //   last_name: "$customer.last_name",
        //   orig_city: "$locations.origin.address.geo.location.address.city",
        //   orig_state:
        //     "$locations.origin.address.geo.location.address.stateCode",
        //   dest_city:
        //     "$locations.destination.address.geo.location.address.city",
        //   dest_state:
        //     "$locations.destination.address.geo.location.address.stateCode",
        //   // destination_address: "$addresses.destination.address.address",
        //   // comments: "$comments",
        //   job_date: "$job_schedule.pickup.job_date",
        // },
      };
      this.axios
        .post(this.serverURL + "/merge_tables", data)
        .then(function(response) {
          that.loading = false;
          console.log(response);
          that.successMessage = response.data;
        })
        .catch(function(error) {
          that.loading = false;
          that.errorMessage = error.data;
        });
    },
  },
  mounted() {
    var that = this;

    this.initSocket();
    this.socket.on("chunk_received", (d) => {
      console.log(d);
      that.serverMessage = d.text;
      // d.text
    });
    this.$root.$on("progress-update", (message) => {
      this.progressMessage = message; // ✅ Update value reactively
    });
    var file_name = "import/" + this.model.json_file_name;
    axios
      .post(this.serverURL + "/get_file", { f: file_name })
      .then((response) => {
        this.import = response.data;
        this.importTables = response.data.tables;
      });
    console.log("mounted");
  },
  watch: {
    progressMessage() {
      if (this.progressMessage == "imported") {
        this.loading = false;
        this.successMessage =
          "Import Completed for " + this.timeElapsed + " seconds";
      }
    },
  },
};
</script>
